(function () {
  function formatMoney(cents, moneyFormat) {
    // Minimal formatter: use Shopify's money_format string with {{amount}}.
    // cents => dollars string with 2 decimals by default
    const amount = (cents / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Failed to fetch cart.js');
    return await res.json();
  }

  function setProgress(barEl, percent) {
    const clamped = Math.max(0, Math.min(100, percent));
    const fill = barEl.querySelector('.free-shipping-bar__progress-fill');
    const progress = barEl.querySelector('.free-shipping-bar__progress');
    if (fill) fill.style.width = clamped + '%';
    if (progress) progress.setAttribute('aria-valuenow', String(Math.round(clamped)));
  }

  function updateMessage(barEl, settings, cartTotal) {
    const threshold = settings.threshold;
    const msgEl = barEl.querySelector('.fsb-message');
    if (!msgEl) return;

    if (settings.hideEmpty && cartTotal <= 0) {
      barEl.classList.add('free-shipping-bar--hidden');
      return;
    } else {
      barEl.classList.remove('free-shipping-bar--hidden');
    }

    if (threshold <= 0) {
      msgEl.textContent = settings.successText;
      setProgress(barEl, 100);
      return;
    }

    if (cartTotal >= threshold) {
      msgEl.textContent = settings.successText;
      setProgress(barEl, 100);
    } else {
      const remaining = threshold - cartTotal;
      const remainingFormatted = formatMoney(remaining, settings.moneyFormat);
      msgEl.textContent = `${settings.beforeText} ${remainingFormatted} ${settings.afterText}`;
      setProgress(barEl, (cartTotal / threshold) * 100);
    }
  }

  async function initBar(barEl) {
    const threshold = parseInt(barEl.dataset.threshold || '0', 10);
    const moneyFormat = (barEl.dataset.currencyFormat || '${{amount}}').replace(/\\u0026/g, '&');

    // Pull copy from the section settings rendered into the DOM:
    // (We’ll read from data attributes if you want later, but simplest is query selectors + defaults.)
    // For now, use “fallbacks” and allow merchants to change in schema (already wired in Liquid text nodes).
    const beforeText = barEl.getAttribute('data-before-text') || null;
    const afterText = barEl.getAttribute('data-after-text') || null;
    const successText = barEl.getAttribute('data-success-text') || null;

    const settings = {
      threshold,
      moneyFormat,
      beforeText: beforeText || 'You’re',
      afterText: afterText || 'away from free shipping',
      successText: successText || 'Nice! You unlocked free shipping.',
      hideEmpty: barEl.hasAttribute('data-hide-empty')
    };

    // Pull the real strings from the section HTML (the merchant edits these)
    // We can store them in hidden spans via Liquid to avoid extra attributes.
    // Quick approach: read them from CSS custom props? Not ideal.
    // Better: embed as data attributes directly from Liquid. We'll do that here:
  }

  async function boot() {
    const bars = document.querySelectorAll('.free-shipping-bar');
    if (!bars.length) return;

    for (const barEl of bars) {
      if (barEl.closest('shopify-section') && barEl.closest('shopify-section').dataset.sectionType === 'free-shipping-bar') {
        // ok
      }
    }

    // Re-init with data attrs approach (set in Liquid below).
    for (const barEl of bars) {
      const settings = {
        threshold: parseInt(barEl.dataset.threshold || '0', 10),
        moneyFormat: (barEl.dataset.currencyFormat || '${{amount}}').replace(/\\u0026/g, '&'),
        beforeText: barEl.dataset.beforeText || 'You’re',
        afterText: barEl.dataset.afterText || 'away from free shipping',
        successText: barEl.dataset.successText || 'Nice! You unlocked free shipping.',
        hideEmpty: barEl.dataset.hideEmpty === 'true'
      };

      try {
        const cart = await getCart();
        updateMessage(barEl, settings, cart.total_price);

        // Listen for cart updates (Dawn fires events in some flows, but not all).
        // We'll also refresh on common interactions.
        document.addEventListener('cart:refresh', async () => {
          const nextCart = await getCart();
          updateMessage(barEl, settings, nextCart.total_price);
        });

        // Fallback: refresh after add-to-cart forms submit
        document.addEventListener('submit', async (e) => {
          const form = e.target;
          if (form && form.matches('form[action^="/cart/add"]')) {
            setTimeout(async () => {
              const nextCart = await getCart();
              updateMessage(barEl, settings, nextCart.total_price);
            }, 600);
          }
        });
      } catch (err) {
        // fail silently
      }
    }
  }

  document.addEventListener('DOMContentLoaded', boot);
})();
